const text =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. PrIn euismod ex mauris. Aliquam luctus lectus non neque lacinia fringilla. Sed vitae ullamcorper mi. Etiam in dictum ex. Nunc ac ipsum interdum, porttitor sapien nec, dignissim augue. Praesent nec orci sed quam sodales venenatis. Donec vulputate ante quis nulla egestas cursus. Integer feugiat ultrices arcu, vitae pretium massa tempor quis. Nullam vestibulum consequat augue, ac interdum neque varius et. Fusce pretium tortor et est tincidunt mattis. Aliquam ornare eleifend turpis sit amet efficitur. Sed nulla est, molestie ut luctus quis, tempor vel metus. Integer dictum purus accumsan purus feugiat molestie. Aenean hendrerit velit libero, nec semper dui fringilla a. Morbi gravida leo sed imperdiet gravida. Aadipiscing elit. PrIn euismod ex mauris. Aliquam luctus lectus non neque lacinia fringilla. Sed vitae ullamcorper mi. Etiam in dictum ex. Nunc ac ipsum interdum, porttitor sapien nec, dignissim augue. Praesent nec orci sed quam sodales venenatis. Donec vulputate ante quis nulla egestas cursus. Integer feugiat ultrices arcu, vitae pretium massa tempor quis. Nullam vestibulum consequat augue, ac interdum neque varius et. Fusce pretium tortor et est tincidunt mattis. Aliquam ornare eleifend turpis sit amet efficitur. Sed nulla est, molestie ut luctus quis, tempor vel metus. Integer dictum purus accumsan purus feugiat molestie. Aenean hendrerit velit libero, nec semper dui fringilla a. ";
const data = [
  {
    id: 1,
    name: "LinkedIn Personalisation",
    topics: [
      {
        id: 1,
        topicName: "Personalize With LinkedIn Recent Activity",
        topicData: {
          heading: "Generate AI First Line",
          subHeading: "Personalised Message 1",
          text: text,
        },
      },
      {
        id: 2,
        topicName: "Personalize With LinkedIn Recent Recomendation",
        topicData: {
          heading: "Generate AI Seccond Line",
          subHeading: "Personalised Message 2",
          text: text,
        },
      },
      {
        id: 3,
        topicName: "Personalize With Achievement",
        topicData: {
          heading: "Generate AI Third Line",
          subHeading: "Personalised Message 3",
          text: text,
        },
      },
      {
        id: 4,
        topicName: "Personalised With Bio/ JobDescription",
        topicData: {
          heading: "Generate AI Fourth Line",
          subHeading: "Personalised Message 4",
          text: text,
        },
      },
    ],
  },
  {
    id: 2,
    name: "Personalised Icebreakers",
    topics: [
      {
        id: 1,
        topicName: "Personalize 1",
        topicData: {
          heading: "Generate AI First Line",
          subHeading: "Personalised Message 1",
          text: text,
        },
      },
      {
        id: 2,
        topicName: "personalise 2",
        topicData: {
          heading: "Generate AI Seccond Line",
          subHeading: "Personalised Message 2",
          text: text,
        },
      },
      {
        id: 3,
        topicName: "Personalize With Achievement",
        topicData: {
          heading: "Generate AI Third Line",
          subHeading: "Personalised Message 3",
          text: text,
        },
      },
      {
        id: 4,
        topicName: "Personalised With Bio/ JobDescription",
        topicData: {
          heading: "Generate AI Fourth Line",
          subHeading: "Personalised Message 4",
          text: text,
        },
      },
    ],
  },
  {
    id: 3,
    name: "BackLink Personalisations",
    topics: [
      {
        id: 1,
        topicName: "Personalize With LinkedIn Recent Activity",
        topicData: {
          heading: "Generate AI First Line",
          subHeading: "Personalised Message 1",
          text: text,
        },
      },
      {
        id: 2,
        topicName: "Personalize With LinkedIn Recent Recomendation",
        topicData: {
          heading: "Generate AI Seccond Line",
          subHeading: "Personalised Message 2",
          text: text,
        },
      },
      {
        id: 3,
        topicName: "Personalize With Achievement",
        topicData: {
          heading: "Generate AI Third Line",
          subHeading: "Personalised Message 3",
          text: text,
        },
      },
      {
        id: 4,
        topicName: "Personalised With Bio/ JobDescription",
        topicData: {
          heading: "Generate AI Fourth Line",
          subHeading: "Personalised Message 4",
          text: text,
        },
      },
    ],
  },
  {
    id: 4,
    name: "Contextaul Pitches",
    topics: [
      {
        id: 1,
        topicName: "Personalize With LinkedIn Recent Activity",
        topicData: {
          heading: "Generate AI First Line",
          subHeading: "Personalised Message 1",
          text: text,
        },
      },
      {
        id: 2,
        topicName: "Personalize With LinkedIn Recent Recomendation",
        topicData: {
          heading: "Generate AI Seccond Line",
          subHeading: "Personalised Message 2",
          text: text,
        },
      },
      {
        id: 3,
        topicName: "Personalize With Achievement",
        topicData: {
          heading: "Generate AI Third Line",
          subHeading: "Personalised Message 3",
          text: text,
        },
      },
      {
        id: 4,
        topicName: "Personalised With Bio/ JobDescription",
        topicData: {
          heading: "Generate AI Fourth Line",
          subHeading: "Personalised Message 4",
          text: text,
        },
      },
    ],
  },
];

export default data;
